namespace GeniuzPOS.RefundReasonReport {
    export namespace PermissionKeys {
        export const RefundReasonReport = "";

        namespace Bybill {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E23\u0E32\u0E22\u0E1A\u0E34\u0E25:View";
        }

        namespace Sumbill {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E23\u0E27\u0E21\u0E1A\u0E34\u0E25:View";
        }

        namespace Byitem {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E23\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:View";
        }
    }
}
